import React from 'react'
import { Link } from 'react-router-dom';
import PageHeaderLight from '../components/shared/PageHeaderLight';
import { useStateValue } from '../StateProvider';
import { getDefaultValue } from '../utils';
import './Dashboard.css';


export default function SignOut(props) {

    const [{ translations }] = useStateValue();

    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find(x=>x.key == str );

        if (translate) return getDefaultValue(translate);
        else return "#" + str;
    };
    return (
        <div className="participant-dashboard">
            <div role="main" className="main page-background">
                <PageHeaderLight />
                <div className="container participant-dashboard__container pt-3 pb-5">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <section
                                className="participant-signout-card text-center"
                                aria-labelledby="signout-heading"
                            >
                                <h2 id="signout-heading" className="participant-signout-card__title participant-dashboard__title">
                                    {translate('You successfully signed out from your account')}
                                </h2>
                                <div className="participant-signout-card__actions">
                                    <Link to="/signin" className="participant-signout-card__link">
                                        {translate('Back to sign in')}
                                    </Link>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
